export default "__VITE_ASSET__ootKNI6B__"